import { Building2, Mail } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";

export default function Sponsors() {
  return (
    <>
      <PageHeader
        eyebrow="Our Sponsors"
        title="Backing The Flock"
        description="Local businesses keep Ducks programs affordable for every family. Sponsor slots for our inaugural 2027 season are open now."
        testid="sponsors-header"
      />
      <section className="pt-6 pb-14 sm:pb-20 bg-[#0A0A0A]" data-testid="sponsors-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="sponsors-grid">
            {[1, 2, 3, 4].map((i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div
                  className="h-44 flex flex-col items-center justify-center border-2 border-dashed border-[#FEE123]/30 bg-[#111111] text-center p-6 transition-colors duration-300 hover:border-[#FEE123]/60"
                  data-testid={`sponsor-slot-${i}`}
                >
                  <Building2 size={28} className="text-[#FEE123]/60" />
                  <p className="mt-3 text-sm font-bold uppercase tracking-widest text-gray-400">Your Business Here</p>
                  <p className="mt-1 text-xs uppercase tracking-widest text-gray-600">2027 Season Sponsor</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-12 bg-[#06220F] border border-[#333333] p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6" data-testid="sponsors-cta">
              <div>
                <h3 className="font-display text-3xl uppercase text-white">Become A Sponsor</h3>
                <p className="mt-2 text-sm text-gray-300">
                  Put your business in front of families across the New Orleans metro area while investing in youth athletes.
                </p>
              </div>
              <a
                href="mailto:louisianaducks27@gmail.com?subject=Sponsorship%20Inquiry%20-%20Louisiana%20Ducks"
                data-testid="sponsors-cta-button"
                className="shrink-0 inline-flex items-center justify-center gap-2 bg-[#FEE123] text-black text-base font-extrabold uppercase tracking-widest px-7 py-3 rounded-sm transition-transform duration-200 hover:scale-105 hover:bg-[#FFEA61]"
              >
                <Mail size={18} /> Email Us
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
